import footer from './footer';
import headerWithoutLogin from './headerWithoutLogin';

export default {
  'component.tagSelect.expand': 'Expand',
  'component.tagSelect.collapse': 'Collapse',
  'component.tagSelect.all': 'All',

  ...footer,
  ...headerWithoutLogin,
};
